import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const Menu = styled.ul`
  position: absolute;
  z-index: 10;
  top: calc(100% + 0.4rem);
  left: 0;
  width: 100%;
  min-width: 20rem;
  padding: 0.4rem;
  margin: 0;
  list-style: none;
  background-color: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  box-shadow: var(--shadow-md);
`;

const MenuTitle = styled.li`
  padding: 0.4rem 0.8rem 0.6rem;
  color: var(--ink-faint);
  font-size: 1.2rem;
`;

const MenuItem = styled.li`
  padding: 0.9rem 0.8rem;
  border-radius: var(--r-xs);
  color: var(--ink);
  font-size: 1.4rem;
  font-weight: 500;
  cursor: pointer;

  :hover,
  :focus {
    background-color: var(--surface-2);
    outline: none;
  }
`;

export { Container, Menu, MenuTitle, MenuItem };
